module.exports = __webpack_public_path__ + "img/restroom.8adef7c7.svg";